import ReCaptchaSettings from '@/settings/recaptcha.json';
import VueRecaptcha from 'vue-recaptcha';
import VueAuthenticate from "vue-authenticate";
import session from '../api/session';

let VueAuthenticateConfig = {
    baseUrl: session.defaults.baseURL,
    tokenPrefix: '',
    tokenName: 'token',
    tokenPath: 'key',
    loginUrl: '/auth/login/',
    logoutUrl: '/auth/logout/',
    registerUrl: '/auth/registration/',
    storageNamespace: '',
    providers: {
        google: {
          clientId: '1051463993687-csv7fodnqb2r4ash8kh54roglg528dq6.apps.googleusercontent.com',
          url: '/auth/social/google/login/'
        },
        facebook: {
          clientId: '2295434517375303',
          url: '/auth/social/facebook/login/'
        }
    }
};

export const userMixin = {
    components: { VueRecaptcha },
    data() {
      return {
        inputs: {
          first_name: null,
          last_name: null,
          email: null,
          username: null,
          password: null,
          password1: null,
          password2: null,
          checkbox: false,
          recaptcha: null,
          perfil: {
            localidade: null,
            aniversario: null,
          }
        },
        modal_header_login: false, /* controla o modal quando o botão acessar do cabeçalho é clicado */
        strength_password: 'ruim',
        color: '#f5365c',
        pwdStrengthText: {
          0: 'ruim',
          1: 'regular',
          2: 'média',
          3: 'boa',
          4: 'forte',
        },
        pwdStrengthColor: {
          0: 'darkred',
          1: '#ff4500',
          2: 'orange',
          3: '#9acd32',
          4: 'green',
        },
        next: this.$route.query.next,
      };
    },
    computed: {
      recaptchaKey() {
        return ReCaptchaSettings.site_key;
      }
    },
    methods: {
      onVerify(token){
        this.inputs.recaptcha = token;
      },
      onExpired(){
        this.inputs.recaptcha = null;
      },
      updateStrengthText (score) {
        this.strength_password = (!score) ? this.pwdStrengthText[0] : this.pwdStrengthText[score];
        this.color = (!score) ? this.pwdStrengthColor[0] : this.pwdStrengthColor[score];        
      },
      changeModalState () {
        this.$store.commit('modal/toggleModal');
      },
      dispatch_error_modal(requestErrorKey) {
        //console.log(requestErrorKey);
        let err = Object.values(requestErrorKey);
        this.$data.modal.body = ( !err[0] ) ? this.$data.modal.body : ( !err[0].isArray ) ? err[0] : err[0][0];
        this.$store.dispatch('modal/invokeStateModal', this.$data.modal);
        if ( this.$refs.recaptcha ) {
          this.$refs.recaptcha.reset();
        }
      },
      dispatch_route_redirect(routeObj) {
        if ( routeObj !== undefined ) {
          this.$router.push(routeObj);
        }else {
          this.$router.push('/');
        }
        this.$data.next = undefined;
      },
      login(event) {
        event.preventDefault();
        let username = this.inputs.username, password = this.inputs.password;
        /* limpa a senha depois de enviar o formulário por segurança */
        this.inputs.password = null;
        if ( !username || !password ) {
          this.$data.modal.body = 'Por favor, preencha os campos para continuar';
          this.$store.dispatch('modal/invokeStateModal', this.$data.modal);
          return false;
        }

        this.$store.dispatch('auth/login', { username, password })
          .then((response) => {
              //let err = Object.values(this.$store.state.auth.loginRequestError);
              if ( this.$store.state.auth.token == null ){
                this.dispatch_error_modal(this.$store.state.auth.loginRequestError);
              }else {
                if ( this.$store.state.modal.showModal == true ) {
                  this.changeModalState();
                }
                this.dispatch_route_redirect(this.$data.next);
              }
          })
      },
      authenticate(provider) {
        const vueAuth = new VueAuthenticate(session, VueAuthenticateConfig);

        vueAuth.authenticate(provider).then((response) => {
          if ( this.$store.state.modal.showModal == true ) {
            this.changeModalState(); 
          }
          //var myToken = localStorage.getItem('token');
          //this.$cookies.set('token', myToken);
          localStorage.removeItem('token');

          /* parte do usuário */
          let responseData = response.data;
          //console.log(responseData);
          this.$store.dispatch('auth/setLoginData', responseData);

          this.$store.dispatch('auth/initialize');
          //commit(SET_LOGIN_DATA, data);
          //this.$store.dispatch()
          this.dispatch_route_redirect(this.$data.next);
        }).catch((error) => {
          //this.dispatch_error_modal(error.data);
          let err = Object.values(error.data);
          let auth_fail_modal =  {
            title: 'Falha no Login!',
            body: ( !err[0] ) ? 'Não foi possível completar a operação' : err[0][0],
            classe: 'modal-danger',
            icon: 'fa fa-times-circle',
            okButton: 'OK',
          };
          this.$store.dispatch('modal/invokeStateModal', auth_fail_modal);
        })
      },
      connect(provider) {
        /* clona as opções da vue-authenticate */
        let _auth_options = VueAuthenticateConfig;
        _auth_options.providers.facebook.url = '/auth/social/facebook/connect/';
        _auth_options.providers.google.url = '/auth/social/google/connect/';
        const vueAuth = new VueAuthenticate(session, _auth_options);
        //console.log(vueAuth);
        vueAuth.authenticate(provider).then((response) => {
          if ( this.$store.state.modal.showModal == true ) {
            this.changeModalState(); 
          }
          localStorage.removeItem('token');
          let responseData = response.data;
          if ( responseData.key == this.$store.state.auth.token ) {
            this.$store.dispatch('auth/setLoginData', responseData);
            this.$store.dispatch('auth/initialize');
            this.load_social_accounts();
          }else {
            let auth_fail_modal =  {
              title: 'Falha ao Conectar!',
              body: 'Outro usuário está vinculado ao perfil social informado!',
              classe: 'modal-danger',
              icon: 'fa fa-times-circle',
              okButton: 'OK',
            };
            this.$store.dispatch('modal/invokeStateModal', auth_fail_modal);
          }
        }).catch((error) => {
          let err = Object.values(error.data);
          let auth_fail_modal =  {
            title: 'Falha ao Conectar!',
            body: ( !err[0] ) ? 'Não foi possível completar a operação' : err[0],
            classe: 'modal-danger',
            icon: 'fa fa-times-circle',
            okButton: 'OK',
          };
          this.$store.dispatch('modal/invokeStateModal', auth_fail_modal);
        })
      },
      disconnect(provider) {
        if ( this.$data.socialAccount[provider] !== undefined ) {
            let socialaccount = this.$data.socialAccount[provider];
            this.$store.dispatch('auth/socialDisconnect', socialaccount).then((response) => {
              if ( this.$store.state.auth.profileRequestError == null ){
                this.$data.socialAccount[provider] = null
              }else {
                this.dispatch_error_modal(this.$store.state.auth.profileRequestError);
              }
            });
        }
      },
      register(event) {
        event.preventDefault();
        let objectInsert = {
          'first_name': this.inputs.first_name,
          'last_name': this.inputs.last_name,
          'username': this.inputs.username,
          'password1': this.inputs.password1,
          'password2': this.inputs.password2,
          'email': this.inputs.email,
          'recaptcha': this.inputs.recaptcha,
        };
        let nullField = false;
        Object.values(objectInsert).forEach(function(e){
          if ( e == null ) {
            nullField = true;
          }
        });
        if ( nullField == true ) {
          this.$data.modal.body = 'Por favor, preencha todos os campos para continuar';
          this.$data.modal.icon = 'fa fa-times-circle';
          this.$store.dispatch('modal/invokeStateModal', this.$data.modal);
          this.$refs.recaptcha.reset();
          return false;
        }
        if ( this.inputs.checkbox == false ) {
          this.$data.modal.body = 'Você precisa estar de acordo com a política de privacidade do site para realizar seu cadastro';
          this.$data.modal.icon = 'fa fa-times-circle';
          this.$store.dispatch('modal/invokeStateModal', this.$data.modal);
          this.$refs.recaptcha.reset();
          return false;
        }
        this.$store.dispatch('signup/createAccount', objectInsert)
          .then((response) => {
              if ( this.$store.state.signup.registrationError == true ){
                this.dispatch_error_modal(this.$store.state.signup.registrationRequestError);
              }
              if ( this.$store.state.signup.registrationCompleted == true ) {
                this.$data.modal.body = 'Conta registrada com sucesso. Para ativar a conta, siga as instruções recebidas no seu e-mail.';
                this.$data.modal.classe = 'modal-success';
                this.$data.modal.icon = 'fa fa-thumbs-up';
                this.$data.modal.title = 'Sucesso no Registro!';
                this.$store.dispatch('modal/invokeStateModal', this.$data.modal);
                this.inputs = {
                  first_name: '',
                  last_name: '',
                  email: '',
                  username: '',
                  password1: '',
                  password2: '',
                };
              }
          })
      },
      send_reset_token(event) {
        event.preventDefault();
        let email = this.inputs.email;
        let recaptcha = this.inputs.recaptcha;
        if ( !email ) {
          this.$data.modal.body = 'Por favor, preencha seu e-mail para continuar';
          this.$data.modal.icon = 'fa fa-times-circle';
          this.$store.dispatch('modal/invokeStateModal', this.$data.modal);
          return false;
          this.$refs.recaptcha.reset();
        }

        this.$store.dispatch('password/sendPasswordResetEmail', { email, recaptcha } )
          .then((response) => {
              if ( this.$store.state.password.emailError == true ){
                this.dispatch_error_modal(this.$store.state.password.emailRequestError);
              }
              if ( this.$store.state.password.emailCompleted == true ) {
                this.$data.modal.body = 'Um link para a recuperação da sua senha foi enviado no seu e-mail de cadastro.';
                this.$data.modal.classe = 'modal-success';
                this.$data.modal.title = 'Operação Concluída!';
                this.$store.dispatch('modal/invokeStateModal', this.$data.modal);
                this.inputs = {
                  email: '',
                };
              }
          })
      },
      reset_password(event) {
        event.preventDefault();
        let password1 = this.inputs.password1, password2 = this.inputs.password2;
        if ( !password1 || !password2 ) {
          this.$data.modal.body = 'Por favor, preencha todos os campos para continuar';
          this.$store.dispatch('modal/invokeStateModal', this.$data.modal);
          return false;
        }else if( password1 !== password2 ) {
          this.$data.modal.body = 'Os dois campos de senha não combinam.';
          this.$store.dispatch('modal/invokeStateModal', this.$data.modal);
          return false;
        }

        let uid = this.$route.params.uid, token = this.$route.params.token;

        this.$store.dispatch('password/resetPassword', { uid, token, password1, password2 })
          .then((response) => {
              if ( this.$store.state.password.resetError == true ){
                this.dispatch_error_modal(this.$store.state.password.resetRequestError);
              }
              if ( this.$store.state.password.resetCompleted == true ) {
                this.$data.modal.body = 'Sua senha foi redefinida com sucesso!';
                this.$data.modal.classe = 'modal-success';
                this.$data.modal.icon = 'fa fa-lock';
                this.$data.modal.title = 'Senha Redefinida!';
                this.$store.dispatch('modal/invokeStateModal', this.$data.modal);
                this.inputs = {
                  password1: '',
                  password2: '',
                };
              }
          })
      },
      change_password(event) {
        event.preventDefault();
        let new_password1 = this.inputs.new_password1, new_password2 = this.inputs.new_password2;
        if ( !new_password1 || !new_password2 ) {
          this.$data.modal.body = 'Por favor, preencha todos os campos para continuar';
          this.$store.dispatch('modal/invokeStateModal', this.$data.modal);
          return false;
        }else if( new_password1 !== new_password2 ) {
          this.$data.modal.body = 'Os dois campos de senha não combinam.';
          this.$store.dispatch('modal/invokeStateModal', this.$data.modal);
          return false;
        }

        this.$store.dispatch('password/changePassword', { new_password1, new_password2 })
          .then((response) => {
              if ( this.$store.state.password.resetError == true ){
                this.dispatch_error_modal(this.$store.state.password.resetRequestError);
              }
              if ( this.$store.state.password.resetCompleted == true ) {
                this.$data.modal.body = 'Sua senha foi redefinida com sucesso!';
                this.$data.modal.classe = 'modal-success';
                this.$data.modal.icon = 'fa fa-lock';
                this.$data.modal.title = 'Senha Redefinida!';
                this.$store.dispatch('modal/invokeStateModal', this.$data.modal);
                this.inputs = {
                  password1: '',
                  password2: '',
                };
              }
          })
      },
      load_profile() {
        return this.$store.dispatch('auth/getProfile')
      },
      update_profile() {
        let patch = {
          first_name: this.$data.inputs.first_name,
          last_name: this.$data.inputs.last_name,
          perfil: {
            localidade: this.$data.inputs.perfil.localidade,
          }
        };
        if ( this.$data.inputs.perfil.aniversario !== null ) patch.perfil.aniversario = this.$data.inputs.perfil.aniversario;
        return this.$store.dispatch('auth/updateProfile', patch);
      },
      load_social_accounts() {
        return this.$store.dispatch('auth/getSocialAccounts').then(response => {
            let obj = {};
            response.forEach(account => {
                if ( account.provider == 'google') {
                    this.$data.socialAccount.google = account.id;
                }else {
                    this.$data.socialAccount.facebook = account.id;
                }
            });
        });
      },

    },
}
